import React, { useState } from "react";
import { CellTmpl, DEFAULT_OPTIONS_PAYLOAD, NameTmpl, reactFormatter } from "../../../common/Table";
import ActDetails from "./ActDetails";
import AddEditAct from "./AddEditAct";
import { useDeleteAct, useGetActs, useGetLaws } from "../../../../backend/masters";
import { EstablishmentTypes, GetMastersBreadcrumb } from "../Master.constants";
import { useExportAct } from "../../../../backend/exports";
import BaseList from '../../../common/BaseList';
import { ActSchema } from '../../../../models/act';
import ActImportModal from "./ActImportModal";

const ACTS_DEFAULT_PAYLOAD = {
  sorts: ['updated_at desc'],
  includes: ['law'],
  include: {
    law: {
      only: ['id','name']
    }
  }
}

function Act() {
    const [breadcrumb] = useState(GetMastersBreadcrumb('Act'));
    const { laws } = useGetLaws({ ...DEFAULT_OPTIONS_PAYLOAD });

    const columns = [
        { title: "Act Name", field: "name", widthGrow: 2, formatter: reactFormatter(<CellTmpl />) },
        { title: "Establishment Type", field: "establishment_type", formatter: reactFormatter(<CellTmpl />) },
        { title: "Law", field: "law", sort_field: 'law_name', formatter: reactFormatter(<NameTmpl />) }
    ]

    const filterConfig = [
        {
            label: 'Establishment Type',
            name: 'establishment_type_eq',
            options: [
                { value: "", label: 'Blank' },
                ...EstablishmentTypes.map(x => {
                    return { value: x, label: x }
                })
            ]
        },
        {
            label: 'Law',
            name: 'law_id_eq',
            options: (laws || []).map((x: any) => {
                return { value: x.id, label: x.name };
            })
        }
    ]

    return (
      <BaseList
        fetchData={useGetActs}
        exportData={useExportAct}
        deleteData={useDeleteAct}
        nameAttribute={'name'}
        columns={columns}
        DetailView={ActDetails}
        FormView={AddEditAct}
        modelSchema={ActSchema}
        initialSort={['name asc']}
        breadcrumb={breadcrumb}
        initialPayload={ACTS_DEFAULT_PAYLOAD}
        ImportComponent={ActImportModal}
        filterConfig={filterConfig}
        title="Mastsers - Acts"
      />
    )
}

export default Act;
